// src/pages/DepositPage.js
import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";

const DepositPage = () => {
  const auth = getAuth();
  const db = getFirestore();
  const [bep20Address, setBep20Address] = useState("");
  const [asset, setAsset] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        window.location.href = "/signin";
        return;
      }

      try {
        const userRef = doc(db, "users", user.uid);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          const data = userSnap.data();
          setBep20Address(data.bep20Address);
          setAsset(data.asset || 0);
        }
      } catch (err) {
        console.error("Error fetching deposit info:", err);
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, [auth, db]);

  if (loading) return <p className="text-center py-10 text-gray-600">Loading...</p>;

  return (
    <div className="min-h-screen bg-gray-100 py-10 px-4 sm:px-6 lg:px-10">
      <div className="max-w-3xl mx-auto bg-white shadow-xl rounded-2xl p-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-6 text-center">Deposit USDT</h1>

        <p className="text-gray-600 mb-4 text-center">
          Your current asset: <span className="font-bold">${asset.toFixed(3)}</span>
        </p>

        <div className="bg-gray-50 p-6 rounded-xl text-center">
          <p className="text-gray-700 mb-2">Send USDT to this BEP-20 address:</p>
          <p className="text-blue-600 font-mono text-lg break-all">{bep20Address}</p>
        </div>
      </div>
    </div>
  );
};

export default DepositPage;
